module.exports = __webpack_public_path__ + "media/images/icon-openlicense@3x-88d32a4e08f993a787fe6a2c36858a0d.png";